(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/play/containers/game-launcher-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/play/containers/game-launcher-wrapper.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const GameLoader = svs.tickets.next.areas.play.components.GameLoader;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.components,
  GameLauncherLeia = _svs$ticketgames$tick.GameLauncherLeia,
  GameWrapper = _svs$ticketgames$tick.GameWrapper,
  GameContext = _svs$ticketgames$tick.GameContext,
  TicketIdPopper = _svs$ticketgames$tick.TicketIdPopper,
  Receipt = _svs$ticketgames$tick.Receipt;
const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils,
  resizeFromFullscreen = _svs$ticketgames$tick2.resizeFromFullscreen,
  resizeFromTicketInfo = _svs$ticketgames$tick2.resizeFromTicketInfo,
  useDefaultEventsLeiaFactory = _svs$ticketgames$tick2.useDefaultEventsLeiaFactory,
  useScratchDefaultEventsLeiaFactory = _svs$ticketgames$tick2.useScratchDefaultEventsLeiaFactory,
  showDialog = _svs$ticketgames$tick2.showDialog,
  tracking = _svs$ticketgames$tick2.tracking;
const showScratchLaterDialog = svs.ticketgames.ticketUtility.utils.showScratchLaterDialog;
const useCustomEvents = svs.tickets.next.areas.play.containers.useCustomEvents;
const NextTopBar = svs.tickets.next.components.NextTopBar;
const TicketPodiumStageFrame = svs.tickets.next.components.ticketCarousel.TicketPodiumStageFrame;
const BottomSheet = svs.tickets.next.components.bottomsheet.BottomSheet;
const Image = svs.content.image_v2.Image;
const Button = svs.ui.ReactButton;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useReducer = _React.useReducer,
  useMemo = _React.useMemo,
  useRef = _React.useRef;
const PLAY_CONTROLS_DELAY_MS = 340;
const PLAY_LOADER_GROW_DURATION_MS = 720;
const PLAY_AGAIN_EXIT_DURATION_MS = 560;
const applyLauncherSize = (container, size) => {
  if (!container || !(size !== null && size !== void 0 && size.width) || !(size !== null && size !== void 0 && size.height)) {
    return;
  }
  container.style.width = "".concat(size.width, "px");
  container.style.height = "".concat(size.height, "px");
};
const getPrefersReducedMotion = () => {
  var _window$matchMedia, _window;
  return Boolean(typeof window !== 'undefined' && ((_window$matchMedia = (_window = window).matchMedia) === null || _window$matchMedia === void 0 || (_window$matchMedia = _window$matchMedia.call(_window, '(prefers-reduced-motion: reduce)')) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches));
};
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAME_REF':
      return _objectSpread(_objectSpread({}, state), {}, {
        gameRef: action.payload
      });
    case 'SET_BET_ID':
      return _objectSpread(_objectSpread({}, state), {}, {
        betId: action.payload
      });
    default:
      return state;
  }
};
const parseBetId = _ref => {
  let wagerId = _ref.wagerId,
    isDemo = _ref.isDemo;
  if (!wagerId || isDemo) {
    return undefined;
  }
  const parsedWagerId = Number.parseInt(wagerId, 10);
  return Number.isNaN(parsedWagerId) ? undefined : parsedWagerId;
};
const getBackFaceIdString = _ref2 => {
  let betId = _ref2.betId,
    isDemo = _ref2.isDemo;
  if (betId) {
    return "Triss LottID ".concat(betId);
  }
  if (isDemo) {
    return 'PROVSPEL';
  }
  return '';
};
const GameLauncherWrapper = _ref3 => {
  var _svs$tickets$data, _ticketInfo$backImage, _ticketInfo$skins;
  let isDemo = _ref3.demo,
    gameIsCompleted = _ref3.gameIsCompleted,
    history = _ref3.history,
    onClose = _ref3.onClose,
    skinId = _ref3.skinId,
    ticketInfo = _ref3.ticketInfo,
    ticketNumber = _ref3.ticketNumber,
    wager = _ref3.wager,
    wagerId = _ref3.wagerId,
    topBarTrackingLocation = _ref3.topBarTrackingLocation;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCardFlipped = _useState2[0],
    setIsCardFlipped = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isGameLoaded = _useState4[0],
    setIsGameLoaded = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    arePlayControlsVisible = _useState6[0],
    setArePlayControlsVisible = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isPlayAgainTransitioning = _useState8[0],
    setIsPlayAgainTransitioning = _useState8[1];
  const _useState9 = useState({}),
    _useState0 = _slicedToArray(_useState9, 2),
    wrapperSize = _useState0[0],
    setWrapperSize = _useState0[1];
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const expandOuterRef = useRef(null);
  const placeholderRef = useRef(null);
  const backFaceRef = useRef(null);
  const observedWrapperSizeRef = useRef(null);
  const loadingStartedAtRef = useRef(null);
  const playAgainTransitionTimeoutRef = useRef(null);
  const initialBetId = parseBetId({
    wagerId,
    isDemo
  });
  const _useReducer = useReducer(reducer, {
      isDemo,
      ticketInfo,
      betId: initialBetId,
      isFullScreenGame,
      wager,
      gameIsCompleted
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  const contextValue = useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    dispatch
  }), [state, dispatch]);
  const shouldShowReceipt = gameIsCompleted && isGameLoaded;
  const hasUnscratchedTicket = ((_svs$tickets$data = svs.tickets.data) === null || _svs$tickets$data === void 0 ? void 0 : _svs$tickets$data.fetchedGames) && svs.tickets.data.fetchedGames.length > 1;
  const updateWrapperSize = useCallback(size => {
    if (!size || isFullScreenGame) {
      return;
    }
    setWrapperSize(prevSize => {
      if (prevSize.width === size.width && prevSize.height === size.height) {
        return prevSize;
      }
      return size;
    });
  }, [isFullScreenGame]);
  const startGameLoadingAnimation = useCallback(() => {
    if (!loadingStartedAtRef.current) {
      loadingStartedAtRef.current = Date.now();
    }
  }, []);
  useEffect(() => {
    const handleGameLoading = () => {
      startGameLoadingAnimation();
    };
    addEventListener('GAME_LOADING', handleGameLoading);
    return () => {
      removeEventListener('GAME_LOADING', handleGameLoading);
    };
  }, [startGameLoadingAnimation]);
  useEffect(() => {
    if (!isGameLoaded) {
      setArePlayControlsVisible(false);
      return undefined;
    }
    startGameLoadingAnimation();
    const loadingElapsedMs = Date.now() - loadingStartedAtRef.current;
    const previewHideDelayMs = Math.max(PLAY_LOADER_GROW_DURATION_MS - loadingElapsedMs, 0);
    const controlsTimeout = window.setTimeout(() => {
      setArePlayControlsVisible(true);
    }, previewHideDelayMs + PLAY_CONTROLS_DELAY_MS);
    return () => {
      window.clearTimeout(controlsTimeout);
    };
  }, [isGameLoaded, startGameLoadingAnimation]);
  useDefaultEventsLeiaFactory({
    ticketInfo,
    isDemo,
    wagerId,
    onClose
  });
  const _useCustomEvents = useCustomEvents({
      ticketInfo,
      isDemo,
      history,
      dispatch,
      setIsGameLoaded,
      hasUnscratchedTicket
    }),
    onPlayAgain = _useCustomEvents.onPlayAgain;
  const handlePlayAgainClick = useCallback(() => {
    if (isPlayAgainTransitioning) {
      return;
    }
    if (isFullScreenGame || getPrefersReducedMotion()) {
      onPlayAgain();
      return;
    }
    setIsPlayAgainTransitioning(true);
    playAgainTransitionTimeoutRef.current = window.setTimeout(() => {
      playAgainTransitionTimeoutRef.current = null;
      onPlayAgain();
    }, PLAY_AGAIN_EXIT_DURATION_MS);
  }, [isFullScreenGame, isPlayAgainTransitioning, onPlayAgain]);
  useEffect(() => () => {
    if (playAgainTransitionTimeoutRef.current) {
      window.clearTimeout(playAgainTransitionTimeoutRef.current);
      playAgainTransitionTimeoutRef.current = null;
    }
  }, []);
  const _useScratchDefaultEve = useScratchDefaultEventsLeiaFactory({
      demo: isDemo,
      gameIsCompleted,
      ticketInfo,
      isFullScreenGame,
      onPlayAgain,
      onClose,
      shouldUseNextConfetti: true
    }),
    isLoading = _useScratchDefaultEve.isLoading,
    gameResult = _useScratchDefaultEve.gameResult,
    notifySoundStatus = _useScratchDefaultEve.notifySoundStatus,
    setShouldShowPlayAgainFooter = _useScratchDefaultEve.setShouldShowPlayAgainFooter,
    shouldShowPlayAgainFooter = _useScratchDefaultEve.shouldShowPlayAgainFooter,
    shouldShowBubbleWinMessage = _useScratchDefaultEve.shouldShowBubbleWinMessage,
    soundStatus = _useScratchDefaultEve.soundStatus,
    wonTicketId = _useScratchDefaultEve.wonTicketId;
  useEffect(() => {
    const init = async () => {
      const product = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding;
      const extraParams = {
        amount: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price,
        product,
        branding: product
      };
      const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
      if (!isLoggedIn && !isDemo) {
        const ticketType = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.alternativeUrl) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type);
        const cancelUrl = "".concat(svs.core.data.baseUrl, "/valja/").concat(ticketType);
        const returnUrl = svs.utils.url.currentPathEncodedParams();
        window.history.replaceState({}, document.title, cancelUrl);
        svs.components.customer_login.login({
          cancelUrl,
          returnUrl,
          returnNewCustomer: true,
          extraParams
        });
      } else {
        var _svs, _svs$setupExtraData;
        await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
          extraData: extraParams
        }));
      }
      svs.tickets.next.utils.utils.hideFooter();
    };
    init();
    return () => {
      svs.tickets.next.utils.utils.showFooter();
    };
  }, [isDemo, ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.alternativeUrl, ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding, ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price, ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type]);
  useEffect(() => {
    if (isFullScreenGame || !expandOuterRef.current || !placeholderRef.current) {
      observedWrapperSizeRef.current = null;
      return undefined;
    }
    return svs.tickets.next.utils.utils.observeContainedSize({
      container: expandOuterRef.current,
      target: placeholderRef.current,
      width: ticketInfo.width,
      height: ticketInfo.height,
      onUpdate: _ref4 => {
        let width = _ref4.width,
          height = _ref4.height;
        const nextSize = {
          width,
          height
        };
        observedWrapperSizeRef.current = nextSize;
        updateWrapperSize(nextSize);
      }
    });
  }, [isFullScreenGame, ticketInfo.height, ticketInfo.width, updateWrapperSize]);
  const onResize = useCallback(container => {
    if (isFullScreenGame) {
      const fullscreenSize = resizeFromFullscreen(container, ticketInfo);
      updateWrapperSize(fullscreenSize);
      return;
    }
    const observedSize = observedWrapperSizeRef.current;
    if (observedSize) {
      applyLauncherSize(container, observedSize);
      updateWrapperSize(observedSize);
      return;
    }
    const size = resizeFromTicketInfo(container, ticketInfo);
    if (!size) {
      return;
    }
    updateWrapperSize(size);
  }, [isFullScreenGame, ticketInfo, updateWrapperSize]);
  const wrapperStyles = isFullScreenGame || !wrapperSize.width || !wrapperSize.height ? {} : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  const bubbleWinOptions = _objectSpread({
    demo: isDemo,
    product: ticketInfo.type
  }, gameResult);
  const playAgainButtonText = ticketInfo.open ? "K\xF6p ny ".concat(ticketInfo.name || ticketInfo.type) : 'Köp ny lott';
  const shouldShowWinMessage = shouldShowBubbleWinMessage && !isFullScreenGame;
  const isTopBarLoading = !isGameLoaded;
  const topBarStyle = !isFullScreenGame && isGameLoaded ? {
    width: wrapperSize.width
  } : {};
  const topBarTrackingLabel = tracking.createTopBarTrackingLabel({
    isDemo,
    location: topBarTrackingLocation,
    gameCode: ticketInfo.type
  });
  const handleTopBarClose = () => {
    var _gameResult$amount;
    showDialog({
      type: 'close',
      isDemo,
      onClose,
      trackingData: {
        label: topBarTrackingLabel,
        value: (_gameResult$amount = gameResult === null || gameResult === void 0 ? void 0 : gameResult.amount) !== null && _gameResult$amount !== void 0 ? _gameResult$amount : -1
      }
    });
  };
  const handleTopBarInfoClick = event => {
    if (isTopBarLoading) {
      var _event$preventDefault;
      event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
      return;
    }
    setIsCardFlipped(prev => !prev);
  };
  const handleTopBarSoundClick = event => {
    if (isTopBarLoading) {
      var _event$preventDefault2;
      event === null || event === void 0 || (_event$preventDefault2 = event.preventDefault) === null || _event$preventDefault2 === void 0 || _event$preventDefault2.call(event);
      return;
    }
    notifySoundStatus(!soundStatus);
  };
  const topBarNode = React.createElement(NextTopBar, {
    isSoundOn: soundStatus,
    onClose: handleTopBarClose,
    onInfoClick: handleTopBarInfoClick,
    onSoundClick: handleTopBarSoundClick,
    trackingLabel: topBarTrackingLabel
  });
  const holderClassName = gameResult ? 'game-complete' : '';
  const stageClassName = ['next-play-ticket-stage', shouldShowWinMessage ? 'next-play-ticket-stage--win-message' : null, isPlayAgainTransitioning ? 'next-play-ticket-stage--play-again-exit' : null].filter(Boolean).join(' ');
  const outerClassName = "next-play-stage u-relative".concat(isGameLoaded ? ' next-play-stage--loaded next-play-stage--zoomed' : '').concat(isCardFlipped ? ' next-play-stage--flipped' : '');
  const isFlipActive = isCardFlipped;
  const cardHostClassName = "next-play-card-host".concat(isFlipActive ? ' next-play-card-host--flipped' : '');
  const canMountGameLauncher = isFullScreenGame || Boolean(wrapperSize.width && wrapperSize.height);
  const gameSpecificParameters = {
    skinId: !(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin) && skinId ? skinId : 1
  };
  const backImageData = (ticketInfo === null || ticketInfo === void 0 || (_ticketInfo$backImage = ticketInfo.backImage) === null || _ticketInfo$backImage === void 0 ? void 0 : _ticketInfo$backImage.image) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.backImage);
  const parsedTicketNumber = parseInt(ticketNumber, 10);
  const hasTicketNumber = Number.isFinite(parsedTicketNumber) && parsedTicketNumber > 0 && parsedTicketNumber < 32;
  const launcherNode = React.createElement(GameWrapper, {
    className: "next-play-game-wrapper",
    context: contextValue,
    styles: wrapperStyles
  }, canMountGameLauncher && React.createElement(GameLauncherLeia, {
    className: "relative",
    gameSpecificParameters: gameSpecificParameters,
    onResize: onResize
  }, !isGameLoaded && React.createElement(GameLoader, {
    image: !isFullScreenGame && ((_ticketInfo$skins = ticketInfo.skins) === null || _ticketInfo$skins === void 0 || (_ticketInfo$skins = _ticketInfo$skins[skinId - 1]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image),
    isLoadingStarted: !isGameLoaded
  }), !isLoading && React.createElement(TicketIdPopper, {
    hasTicketNumber: false
  })), hasTicketNumber && React.createElement("div", {
    "aria-hidden": "true",
    className: "ticket-carousel__number ticket-carousel__number--fixed-size"
  }, parsedTicketNumber));
  const gameLauncherContent = launcherNode;
  let backImageNode = null;
  if (backImageData) {
    const normalizedBackImage = typeof backImageData === 'string' ? {
      src: backImageData
    } : backImageData;
    backImageNode = React.createElement(Image, {
      cssSelectors: "next-play-card__back-image",
      image: _objectSpread(_objectSpread({}, normalizedBackImage), {}, {
        altText: (normalizedBackImage === null || normalizedBackImage === void 0 ? void 0 : normalizedBackImage.altText) || 'Baksida av lott'
      })
    });
  }
  const backFaceIdString = getBackFaceIdString({
    betId: state.betId,
    isDemo
  });
  const ticketNameStyle = svs.tickets.next.utils.utils.getTicketNameStyle(wrapperSize.width || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width), wrapperSize.height || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height));
  const backFaceNode = React.createElement(GameWrapper, {
    className: "next-play-game-wrapper",
    context: contextValue,
    styles: wrapperStyles
  }, React.createElement("div", {
    className: "next-play-card__back-surface f-body",
    ref: backFaceRef
  }, backImageNode, backFaceIdString && React.createElement("h3", {
    className: "h3 ticket-id-popper--back",
    style: ticketNameStyle
  }, backFaceIdString)));
  const playAgainBottomSheetStyle = _objectSpread({
    transition: 'opacity 220ms ease, transform 360ms cubic-bezier(0.22, 0.61, 0.36, 1)'
  }, isPlayAgainTransitioning ? {
    opacity: 0,
    pointerEvents: 'none',
    transform: 'translate(-50%, 110%)'
  } : null);
  return React.createElement(React.Fragment, null, React.createElement(TicketPodiumStageFrame, {
    before: React.createElement(React.Fragment, null, shouldShowWinMessage && React.createElement("div", {
      className: "qa-win-message-container next-play-win-message game-header relative"
    }, React.createElement(BubbleWinMessage, {
      options: bubbleWinOptions
    })), !shouldShowWinMessage && React.createElement("div", {
      className: "next-play-topbar".concat(arePlayControlsVisible ? ' next-play-topbar--visible' : '').concat(isTopBarLoading ? ' next-play-topbar--loading' : ''),
      style: topBarStyle
    }, React.createElement(GameContext.Provider, {
      value: {
        ticketInfo
      }
    }, topBarNode))),
    className: stageClassName,
    growAreaRef: expandOuterRef,
    holderClassName: holderClassName,
    placeholderRef: placeholderRef,
    ticketInfo: ticketInfo
  }, React.createElement("div", {
    className: outerClassName
  }, React.createElement("div", {
    className: cardHostClassName
  }, React.createElement("div", {
    "aria-hidden": isFlipActive,
    className: "next-play-card-front-layer"
  }, gameLauncherContent), React.createElement("div", {
    "aria-hidden": !isFlipActive,
    className: "next-play-card-back-layer"
  }, backFaceNode)))), shouldShowReceipt && React.createElement(Receipt, {
    className: "next-ticket-receipt-margin-bottom",
    fetchedGame: wager,
    show: shouldShowReceipt,
    ticketInfo: ticketInfo
  }), wonTicketId && !shouldShowPlayAgainFooter && React.createElement(BottomSheet, {
    className: "won-ticket-bottomsheet",
    title: "Vad vill du g\xF6ra nu?"
  }, React.createElement("div", {
    className: "padding-h-2 padding-top-1"
  }, React.createElement("p", {
    className: "margin-bottom-2"
  }, "Du kan skrapa din nya Triss nu p\xE5 en g\xE5ng."), React.createElement("p", {
    className: "margin-bottom-2"
  }, "Vill du hellre dra ut p\xE5 sp\xE4nningen lite? D\xE5 kan du v\xE4lja att skrapa lotten senare."), React.createElement(Button, {
    block: true,
    className: "margin-bottom-1 qa-scratch-now",
    inverted: true,
    onClick: () => {
      svs.utils.url.navigate(svs.core.urlMapping.get('triss_BetDetail').replace(':wagerId', wonTicketId));
    }
  }, "Skrapa din Triss"), React.createElement(Button, {
    block: true,
    className: "margin-bottom-2 qa-scratch-later",
    onClick: () => {
      showScratchLaterDialog({
        onClose: () => {
          setShouldShowPlayAgainFooter(true);
        }
      });
    },
    transparent: true
  }, "Skrapa senare"))), shouldShowPlayAgainFooter && React.createElement(BottomSheet, {
    className: "next-play-again-bottom-sheet",
    style: playAgainBottomSheetStyle
  }, React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-column padding-2"
  }, React.createElement(Button, {
    block: true,
    className: "qa-play-again-btn",
    disabled: isPlayAgainTransitioning,
    focus: true,
    onClick: handlePlayAgainClick,
    type: "button"
  }, hasUnscratchedTicket ? 'Skrapa nästa lott' : playAgainButtonText))));
};
setGlobal('svs.tickets.next.areas.play.containers.GameLauncherWrapper', GameLauncherWrapper);

 })(window);